import React from 'react'
import {
    Button,
    Image,
    MarketingModal,
    ModalDialog,
} from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from '../containers/LearnerDashboardHeader/ConfirmEmailBanner/messages';
import confirmEmailSVG from '../assets/confirm-email.svg'

const ConfirmEmailPopup = ({ showConfirmModal, setShowConfirmModal }) => {
    const { formatMessage } = useIntl();

    return (
        <>
            {showConfirmModal &&
                <MarketingModal
                    title=""
                    className="activation-popup"
                    isOpen={showConfirmModal}
                    // onClose={() => setShowConfirmModal(false)}
                    hasCloseButton={false}
                    heroNode={(
                        <ModalDialog.Hero className="bg-gray-300">
                            <Image
                                className="m-auto"
                                src={confirmEmailSVG}
                                alt={formatMessage(messages.confirmEmailImageAlt)}
                            />
                        </ModalDialog.Hero>
                    )}
                    footerNode={(
                        <Button className="mx-auto my-3" variant="danger" onClick={() => setShowConfirmModal(false)}>
                            {formatMessage(messages.verifiedConfirmEmailButton)}
                        </Button>
                    )}
                >
                    <h1 className="text-center p-3">{formatMessage(messages.confirmEmailModalHeader)}</h1>
                    <p className="text-center">{formatMessage(messages.confirmEmailModalBody)}</p>
                </MarketingModal>
            }
        </>
    )
}

export default ConfirmEmailPopup;
